import styled from 'styled-components';
import theme from 'shared/themes/default';

interface PillProps {
  color?: string;
  fontColor?: string;
}

const PillStyled = styled.div<PillProps>`
  display: inline-block;
  font-family: ${theme.fonts.primary};
  background: ${(props) => props.color};
  color: ${(props) => props.fontColor};
  font-size: 20px;
  font-weight: 600;
  border-radius: 6px;
  padding: 10px 16px;
  ${theme.breakpoints.mobile} {
    padding: 6px 12px;
    font-size: 14px;
  }
`;

const Pill = ({
  color = theme.palette.mainDark,
  fontColor = theme.palette.lightPure,
  ...props
}: PillProps) => <PillStyled color={color} fontColor={fontColor} {...props} />;

export default Pill;
export type { PillProps };
